import Reveal from "./Reveal";
import { TESTIMONIALS } from "@/data/content";

const Testimonials = () => {
  return (
    <section
      className="relative py-24 lg:py-32 max-w-7xl mx-auto px-6 lg:px-10"
      data-testid="testimonials-section"
    >
      <Reveal>
        <p className="font-mono-accent text-xs text-[#00D2D3] tracking-[0.25em] uppercase mb-4">
          Quem confiou
        </p>
        <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-white max-w-2xl tracking-tight">
          Resultados que falam por quem já construiu com a gente.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal delay={i * 0.12} key={t.name}>
            <div
              className="h-full flex flex-col justify-between rounded-2xl border border-white/10 bg-white/[0.02] backdrop-blur-sm p-8 transition-all duration-500 hover:border-[#00D2D3]/30 hover:-translate-y-1"
              data-testid={`testimonial-card-${i}`}
            >
              <p className="font-outfit text-lg text-white/85 leading-snug">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-8 pt-6 border-t border-white/10">
                <p className="font-manrope font-semibold text-white text-sm">
                  {t.name}
                </p>
                <p className="font-manrope text-white/45 text-xs mt-1">
                  {t.role}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
